(function () {
    'use strict';
    // DO NOT EDIT THIS FILE, EDIT THE GULP TASK NGCONSTANT SETTINGS INSTEAD WHICH GENERATES THIS FILE
    angular
        .module('lmsApp')
        .constant('VERSION', "1.4.1")
        .constant('GIT', {
	"message": "Merge branch 'dev' into 'master'\n\nfix: Ранее родителям не было видно ответов на тесты их детей + учителя не видели ответы.\n\nSee merge request lms-mob-edu/lms-legacy/legacy-front!75",
	"commit": "5e731aefe2e6778397cc58135a73f333cd53c27f",
	"branch": "master",
	"date": "2023-01-30T15:41:57.000Z"
})
        .constant('DEBUG_INFO_ENABLED', false)
        .constant('ENV', "prod")
        .constant('API', {
	"newAdmin": "/adm",
	"course": "/course"
})
        .constant('innopolis', undefined)
        .constant('innopolis_stage', undefined)
;
})();
